<template>
    <div class="form-group w-100">
            <label v-if="!nonshowlabel">เลือกขนาดพัสดุ {{ ["KRYDS", "DEFAULT"].includes(courier_key) ? '': 'หรือ กรอกขนาดพัสดุในช่องด้านล่าง'}} (เซนติเมตร)
            </label>
            <v-select    
                label="title_box"
                :options="autoBox"
                :disabled="favoriteDimension"
                v-model="size.boxSize"
                @input="setSelectedboxSize"
                :reduce="titleBox => titleBox.code"
                :class="{ 'bd-danger': openBorderError }"
            >
                <template v-slot:prepend>
                    <i class="fas fa-star"></i>
                </template>
                <template v-slot:option="option">
                    <span class="d-flex align-items-center">
                        <span class="flex-grow-1 w-100 text-truncate">
                            {{ option.title_box }}
                        </span>
                        <span class="d-flex justify-content-flex-end">
                            <i :class="['fa-sm color-star pl-1', (option.pointer > 0) 
                                ?'fas fa-star text-yellow'
                                :( countStar >= 5 ) ? '' : 'far fa-star']" 
                                @click="setFavorite(option)"
                            ></i>
                        </span>
                    </span>
                </template>
            </v-select>
    </div>
</template>
<script>
import { getFavoriteSizeBox, createFavoriteSizeBox, deleteFavoriteSizeBox } from "@/axios/sizeBox.js";

export default {
  name: "autobox",
  props:[
    "width" , "length" , "height" , "keyBox" , "courier_key" , 'size', "listSize", "favoriteDimension", "nonshowlabel", 'openBorderError'
  ],
  watch: { 
    keyBox: function(newVal, oldVal) { 
      if (this.courier_key == 'SCG') {
        this.setSelectedboxSize(newVal)
      }
    }
  },
  methods: {
    setSelectedboxSize(boxSize){
      let size = this.autoBox.find( data => data.code === boxSize );
      if (size) {
        if( size.hasOwnProperty('weight') ){
          this.$emit('update:weight', size.weight);
          if( this.$THEME.unitKG ){
            this.$emit('update:weightKG', size.weightKG);
          }
        }
        this.$emit('update:width', size.width);
        this.$emit('update:length', size.length);
        this.$emit('update:height', size.height);
        this.$emit('update:keyBox', size.code);
        this.$emit('itemPreRate');
      }
    },
    setFavorite( option ){
        let i = this.autoBox.findIndex( box => {
            return box.code == option.code
        });

        if( option.pointer > 0){
            deleteFavoriteSizeBox(this.courier_key , option.pointer).then( res => {
                if(res.success == 1){
                    if( i > -1 ){
                        this.$set(this.autoBox[i], 'pointer', null )
                    }
                }
            })
        }else{
            createFavoriteSizeBox(this.courier_key , option.code).then( res => {
                if(res.success == 1){
                    if( i > -1 ){
                        this.$set(this.autoBox[i], 'pointer', true )
                    }
                }
            })
        }
    }
  },
  computed:{
    autoBox(){
        let resBox = this.listSize.defaultSize
        if( 'SCG' == this.courier_key){
            resBox = this.listSize.SCGSize
        }else if( 'KRYS' == this.courier_key && new Date().getTime() < new Date('2023-09-05 00:00:00').getTime() ){
            resBox = this.listSize.KRYSSize
        }else if( ['SCGC' , 'SCGF'].includes( this.courier_key ) ){
            resBox = this.listSize.SCGSize.filter(function (col) {
            return [ 'Envelop' , 'PM' , 'PL' , '50' , '90', '140' , '160' , '180' , '200', '250'
            ].indexOf(col.code) < 0
            }) 
        }else if( 'DEFAULT' == this.courier_key ){
            resBox = [ ...this.listSize.defaultSize, ...this.listSize.KRYSSize, ...this.listSize.SCGSize ];
        } else if ('FLEDS' == this.courier_key) {
            resBox = [...this.listSize.defaultSize]
        }

        getFavoriteSizeBox(this.courier_key).then( data => {
            resBox.map( (resItem , index) => {
                let i = data.item.findIndex( box => {
                    return box.size == resItem.code
                });
                this.$set(resBox[index], 'pointer', (i > -1) ? data.item[i].id : null )
            })
        })

        return resBox.sort( (a,b) => { 
            return (a.pointer===null)-(b.pointer===null) || +(a.pointer>b.pointer)||-(a.pointer<b.pointer);
        })
    },
    countStar(){
        let boxSize = this.autoBox.filter( box => box.pointer > 0 );
        return boxSize.length;
    }
  }
};
</script>